import { render, staticRenderFns } from "./CourseCreateV2.vue?vue&type=template&id=c5807e0e&"
import script from "./CourseCreateV2.vue?vue&type=script&lang=ts&"
export * from "./CourseCreateV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports